import React from 'react';
interface TopBarProps {
  onAddToCart: () => void;
}
export function TopBar({
  onAddToCart
}: TopBarProps) {
  return <div className="fixed top-0 left-0 right-0 bg-dark-primary border-b border-border-subtle z-[100] px-4 py-3 hidden md:block" data-id="element-657">
      <div className="max-w-content mx-auto flex items-center justify-between" data-id="element-658">
        {/* Left */}
        <div className="flex items-center gap-2" data-id="element-659">
          <div className="w-2 h-2 rounded-full bg-gold" data-id="element-660"></div>
          <span className="font-serif font-bold text-cream text-sm tracking-wide" data-id="element-661">
            El Azúcar Silencioso
          </span>
        </div>

        {/* Center */}
        <div className="font-mono text-[11px] text-gray-warm uppercase tracking-widest hidden lg:block" data-id="element-662">
          Ebook + 3 Bonos <span className="text-border-subtle mx-2" data-id="element-663">|</span>{' '}
          Descarga Inmediata <span className="text-border-subtle mx-2" data-id="element-664">|</span>{' '}
          PDF
        </div>

        {/* Right */}
        <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" onClick={onAddToCart} className="border border-gold text-gold hover:bg-gold hover:text-dark-primary font-sans text-xs font-bold py-2 px-4 rounded transition-colors uppercase tracking-wide" data-id="element-665">
          Descargar Ahora — $17.95
        </a>
      </div>
    </div>;
}